var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"disabled":_vm.readonly,"label":"Prognos","outlined":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }